import { getCloudinaryUrl } from '../utils/cloudinary';

const bandMembers = [
    {
        name: 'Samuel John',
        role: 'Lead Vocals',
        bio: `Samuel John, from Isanti County, MN, is attempting to carve his own path in country rock music. Inspired by his mother's musical journey and his brother Ben's gigging experience, Samuel draws from classic artists like Waylon Jennings and modern influences like Cody Jinks and Tyler Childers. In 2023, he formed the Samuel John Band to showcase original country rock music.`,
        image: 'bio-sam.jpg',
    },
    {
        name: 'John Wander',
        role: 'Drums',
        bio: `From Moorhead, MN, John brings 20 years of learn-by-ear drumming experience. Starting at age 10 with the Western Minnesota Steam Threshers Reunion, John has played with diverse jazz, country, and rock groups. When not perfecting drum fills, he's a digital creative, podcast host, or exploring Minnesota's roads on his motorcycle.`,
        image: 'bio-john.jpg',
    },
    {
        name: 'Brandon Nelson',
        role: 'Lead Guitar',
        bio: `Brandon started at Stillwater's church band at 14 before moving through metal and prog rock bands. After seven years with funk group Crooke, a chance meeting with Sam at an open mic reignited his passion. Today, he leads worship at his church and hosts the weekly open-mic at the Terminal Bar in Northeast Minneapolis.`,
        image: 'bio-brandon.jpg',
    },
    {
        name: 'Jake Abel',
        role: 'Bass Guitar',
        bio: `The chaotic energy bassist of the band, Jake juggles teaching music, restaurant managing, and delivering for Door Dash. Known for his infectious enthusiasm and bowling prowess, Jake's bass lines provide the groove foundation for the Samuel John Band's sound.`,
        image: 'bio-jake.jpg',
    },
];

export function BioPage() {
    return (
        <div className="w-full">
            {/* Hero Section with Band Photo */}
            <div
                className="relative w-full h-96 bg-cover bg-center"
                style={{
                    backgroundImage: `url('${getCloudinaryUrl('band-northwoods-1.jpg', { width: 1920, quality: 'auto' })}')`,
                }}
            >
                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/50"></div>

                {/* Content */}
                <div className="relative h-full flex items-center justify-center">
                    <div className="text-center">
                        <h1 className="text-5xl md:text-6xl font-bold text-primary mb-4">Meet The Band</h1>
                        <div className="h-1 w-24 bg-primary mx-auto"></div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-5xl mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {bandMembers.map((member, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center text-center p-6 bg-card border border-border rounded-lg hover:border-primary transition-all"
                        >
                            <img
                                src={getCloudinaryUrl(member.image, {
                                    width: 400,
                                    height: 400,
                                    crop: 'fill',
                                    quality: 'auto',
                                })}
                                alt={member.name}
                                className="w-48 h-48 object-cover rounded-full mb-4 border-2 border-primary"
                            />
                            <h3 className="mb-1 text-primary text-lg font-semibold">{member.name}</h3>
                            <p className="text-sm font-semibold text-primary mb-3">{member.role}</p>
                            <p className="text-sm text-foreground leading-relaxed">{member.bio}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
